<template>
  <div id="public-section" style="width: 100%">
    <v-app id="app" style="background: #f2f8ff !important">
      <v-snackbar
        app
        v-model="show"
        :color="color"
        :timeout="timeout"
        top
        right
        rounded
        elevation="24"
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="show = false"> Close </v-btn>
        </template>
      </v-snackbar>
      <router-view :key="$route.path"></router-view>
    </v-app>
  </div>
</template>

<script>
import "firebase/compat/app";
import "firebase/compat/messaging";
import platform from "platform";
import newAxios from "@/api/newAxios";
import { isAuthenticated } from "@/common/commonFunctions";
export default {
  components: {},
  name: "App",
  data() {
    return {
      text: "",
      color: "",
      timeout: 4000,
      show: false,
      ipAddress: "",
    };
  },
  created() {
    this.getIpAddress();
    this.getDeviceInfo();
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "snackBar/SHOW_MESSAGE") {
        this.text = state.snackBar.text;
        this.color = state.snackBar.color;
        this.timeout = state.snackBar.timeout;
        this.show = true;
      }
    });
  },
  mounted() {
    // Set up the interval to call the UTM API every 10 seconds
    // this.intervalId = setInterval(() => {
    //   this.callUtmApi();
    // }, 10000);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // Start the API calls only if the page is visible
    if (document.visibilityState === "visible") {
      this.startApiCall();
    }
  },
  methods: {
    startApiCall() {
      // Set up the interval to call the UTM API every 10 seconds
      this.intervalId = setInterval(() => {
        this.callUtmApi();
      }, 10000);
    },
    stopApiCall() {
      // Clear the interval to stop the API calls
      clearInterval(this.intervalId);
    },
    handleVisibilityChange() {
      // Start or stop the API calls based on the visibility state
      if (document.visibilityState === "visible") {
        this.startApiCall();
      } else {
        this.stopApiCall();
      }
    },
    getIpAddress() {
      fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          this.ipAddress = data.ip;
          // console.log("Your Public IP Address:", data.ip);
        })
        .catch((error) => {
          console.error("Error fetching IP:", error);
        });
    },
    getDeviceInfo() {
      const device = platform;
      return {
        name: device.name,
        version: device.version,
        os: device.os ? device.os.toString() : null,
        manufacturer: device.manufacturer || null,
        product: device.product || null,
      };
    },
    async callUtmApi() {
      if (isAuthenticated()) {
        const onSuccess = () => {};
        const onFailure = () => {};
        let formData = {};
        formData["medium"] = localStorage.getItem("utm_medium");
        formData["source"] = localStorage.getItem("utm_source");
        formData["campaign"] = localStorage.getItem("utm_campaign");
        formData["utm_id"] = localStorage.getItem("utm_id");
        formData["utm_content"] = localStorage.getItem("utm_content");
        formData["utm_term"] = localStorage.getItem("utm_term");
        formData["ipaddress"] = this.ipAddress;
        formData["device"] = this.getDeviceInfo();
        formData["user"] = localStorage.getItem("user_id");
        newAxios("patch", "/api/update-user-session/", {
          onSuccess,
          onFailure,
          params: formData,
          isTokenRequired: true,
        });
      } else {
        const onSuccess = () => {};
        const onFailure = () => {};
        let formData = {};
        formData["medium"] = localStorage.getItem("utm_medium");
        formData["source"] = localStorage.getItem("utm_source");
        formData["campaign"] = localStorage.getItem("utm_campaign");
        formData["utm_id"] = localStorage.getItem("utm_id");
        formData["utm_content"] = localStorage.getItem("utm_content");
        formData["utm_term"] = localStorage.getItem("utm_term");
        formData["ipaddress"] = this.ipAddress;
        formData["device"] = this.getDeviceInfo();
        // formData["user"] = localStorage.getItem("user_id");
        newAxios("patch", "/api/update-user-session/", {
          onSuccess,
          onFailure,
          params: formData,
          isTokenRequired: false,
        });
      }
    },
  },
  metaInfo() {
    return {
      // title: "Covesto",
      // titleTemplate: "%s - Covesto",
      meta: [
        { property: "og:title", content: "Covesto" },
        { property: "og:type", content: "article" },
        { property: "og:url", content: "http://covesto.in" }, // here it is just ngrok for my test
        {
          property: "og:description",
          content:
            "Individual Investing To Community 'Covesting'. We are building the community investing ecosystem for new-age investors.",
        },
        { property: "og:image", content: `${require("./assets/Logo.svg")}` },
        {
          property: "twitter:title",
          content: `${require("./assets/Logo.svg")}`,
        },
        {
          property: "twitter:description",
          content:
            "Individual Investing To Community 'Covesting'. We are building the community investing ecosystem for new-age investors.",
        },
        {
          property: "twitter:image",
          content: `${require("./assets/Logo.svg")}`,
        },
        {
          property: "twitter:card",
          content:
            "Individual Investing To Community 'Covesting'. We are building the community investing ecosystem for new-age investors.",
        },
        { property: "og:image:width", content: "400" },
        { property: "og:site_name", content: "covesto.in" },
      ],
    };
  },
};
</script>
<style>
html {
  scroll-behavior: smooth;
}
.col {
  padding: 0px 0px !important;
}
.pointer {
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f7f7f7;
}

::-webkit-scrollbar-thumb {
  background-color: #adaebb;
  border-radius: 20px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
}
</style>
<style lang="scss" scoped>
@font-face {
  font-family: "Avenir";
  src: url(./assets/fonts/AvenirRegular/AvenirRegular.ttf) format("TrueType");
  letter-spacing: 0px;
}
*,
#public-section {
  font-family: "Avenir";
}

.drawer {
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  border-radius: 8px;
  top: 0px !important;
  bottom: 0px !important;
  margin: 0px !important;
  padding: 0px !important;
}
.main-container {
  display: flex;
}

.logo {
  width: 170px;
  height: 100px;
  margin-left: 14px;
  cursor: pointer;
}

.right-container {
  display: flex;
  flex-direction: column;
}
.item-title {
  font-size: 18px !important;
}

.social-media-images {
  text-align: center;
  padding-bottom: 20px;

  p {
    color: rgba(51, 51, 51, 0.87);
  }
}
.notification-mobile {
  display: none;
}
.notification-desktop {
  display: block;
}

.nav__text {
  display: none !important;
}
.covesto___logo__mobile {
  display: block !important;
  height: 40px;
  cursor: pointer;
  margin: auto 30px !important;
  width: 100%;
}
.active-page {
  background: #2d8cff;

  .item-title {
    color: white;
  }

  .nav-icon {
    color: white !important;
  }
}

.social-media-images img {
  width: 30px;
  height: 30px;
  margin: 0 7px;
  cursor: pointer;
}
.playStore img {
  width: 200px;
  height: 80px;
  margin: 0 7px;
  cursor: pointer;
}

.drawer {
  display: flex;
}
@media all and (max-width: 600px) {
  .nav__text {
    display: none !important;
  }
  .nav-foot {
    margin-bottom: 100px !important;
  }
  .notification-mobile {
    display: inline;
    padding: 5px;
  }
  .notification-desktop {
    display: none;
  }
}

.notification-btn {
  border: 0.5px solid rgba(51, 51, 51, 0.08);
  box-sizing: border-box;
  border-radius: 8px;
}
@media all and (min-width: 1000px) {
  .nav__text {
    padding-left: 20px;
    display: inline !important;
  }
}
.covesto___logo__mobile {
  display: none !important;
}
</style>
